/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A17Inputs */

const et_faq_a17 = /** @type {(inputs: Faq_A17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-poe arendus, mis tõesti müüb, algab kolmest alussammust: kiire laadimisaeg, lihtne kasutajakogemus ja selge ostuteekond. Ilma nende sammudeta on ka ilusaim e-pood kuluallikas, mitte müügikanal. ScalingWebs arendab e-poode, mis on optimeeritud SEO jaoks, mobiilisõbralikud, kiired ja ühendatud müügi- ning automaatikasüsteemidega. Liigutame fookuse disainilt müügile.`)
};

const en_faq_a17 = /** @type {(inputs: Faq_A17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An e-commerce site that actually sells starts with three foundations: fast loading speed, a simple user experience, and a clear purchase journey. Without these, even the most beautiful online shop is a cost center, not a sales channel. ScalingWebs develops e-commerce websites optimized for SEO, mobile-friendly, fast, and connected to sales and automation systems. We shift the focus from design to revenue.`)
};

/**
* | output |
* | --- |
* | "An e-commerce site that actually sells starts with three foundations: fast loading speed, a simple user experience, and a clear purchase journey. Without the..." |
*
* @param {Faq_A17Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a17 = /** @type {((inputs?: Faq_A17Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A17Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a17(inputs)
	return en_faq_a17(inputs)
});